export default "__VITE_ASSET__Ber3fWis__"